var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 48,
    width: 38,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    strokeWidth: 1.5,
    stroke: "#2058E7",
    fill: "#2058E7",
    d: "m1.24,14.98c3.94,-17.32 29.6,-17.3 33.52,0.02c2.3,10.16 -4.02,18.76 -9.56,24.08c-8.2,7.8744 -6.2,7.9222 -14.42,0c-5.52,-5.32 -11.84,-13.94 -9.54,-24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    strokeWidth: 1.5,
    stroke: "#2058E7",
    fill: "white",
    d: "m18,24.86c3.4463,0 6.24,-2.7937 6.24,-6.24c0,-3.4463 -2.7937,-6.24 -6.24,-6.24c-3.4462,0 -6.24,2.7937 -6.24,6.24c0,3.4463 2.7938,6.24 6.24,6.24z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerIcon);
export default __webpack_public_path__ + "static/media/MapMarkerIcon.6bbde75fbbe96ed22e486fcb873b0b70.svg";
export { ForwardRef as ReactComponent };